import React from "react";
import { Alert, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const NotificationSection = ({ error, success, setError, setSuccess }) => {
  return (
    <>
      {/* 알림 메시지 */}
      {error && (
        <Alert 
          severity="error"
          action={
            <IconButton
              size="small"
              onClick={() => setError(null)}
              sx={{ color: "inherit" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{ marginTop: 2, marginBottom: 2 }}
        >
          {error}
        </Alert>
      )}

      {success && (
        <Alert 
          severity="success"
          action={
            <IconButton
              size="small"
              onClick={() => setSuccess(null)}
              sx={{ color: "inherit" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{ marginTop: 2, marginBottom: 2 }}
        >
          {success}
        </Alert>
      )}
    </>
  );
};

export default NotificationSection; 